export interface ProcessEfficiencyRow {
    id: number;
    subject: string;
    start_date: Date;
    closed_on?: Date | null;
    close_date?: Date | null;
    project: string;
    project_id: number;
    assignee?: string | null;
    assignee_id?: number | null;
    total_spent_time: number;
    estimated_time: number | null;
    development_stage: string | null;
}

export function ProcessEfficiencyRowFromJSON(json: any): ProcessEfficiencyRow {
    return {
        id: json["id"],
        subject: json["subject"],
        start_date: new Date(json["start_date"]),
        closed_on: json["closed_on"] ? new Date(json["closed_on"]) : null,
        close_date: json["close_date"] ? new Date(json["close_date"]) : null,
        project: json["project"],
        project_id: json["project_id"],
        assignee: json["assignee"] || null,
        assignee_id: json["assignee_id"] || null,
        estimated_time: json["estimated_time"] || null,
        total_spent_time: json["total_spent_time"],
        development_stage: json["development_stage"] || null,
    };
}


export interface MaintenanceEpicRow {
    project_id: number;
    project: string;
    maintenance_hours: string | null;
    start_of_maintenance: Date | null;
    end_of_maintenance: Date | null;
}

export function MaintenanceEpicRowFromJSON(json: any): MaintenanceEpicRow {
    return {
        project_id: json["project_id"],
        project: json["project"],
        maintenance_hours: json["maintenance_hours"] || null,
        start_of_maintenance: json["start_of_maintenance"]
            ? new Date(json["start_of_maintenance"])
            : null,
        end_of_maintenance: json["end_of_maintenance"]
            ? new Date(json["end_of_maintenance"])
            : null,
    };
}
